export default __webpack_public_path__ + "static/media/auteuil8.355f7e5a.jpg";